import React, {Component, Fragment} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Card, Button, Popconfirm, Divider, message, notification, InputNumber} from "antd";
import StandardTable from "../../components/StandardTable";
import FormModal from "../../components/FormModal";
import * as api from "../../api/industry";

class Industry extends Component {

    columns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: '名称',
            dataIndex: 'name',
        },
        {
            title: '操作',
            render: (record) => {
                return (
                    <span>
                        <Fragment>
                            <a onClick={() => this.handleModalShow(record)}>编辑</a>
                            <Divider type={"vertical"} />
                        </Fragment>
                        <Popconfirm title={"是否确认删除"} onConfirm={() => {
                            this.handleDelete(record.id)
                        }}>
                            <a>删除</a>
                        </Popconfirm>
                    </span>
                )
            }
        }
    ];

    modifyFields = [
        {
            dataIndex: 'id',
            visible: false
        },
        {
            title: '名称',
            dataIndex: 'name',
            rules: [{
                required: true, message: '请输入名称',
            }],
        }
    ];

    dataTable = undefined

    state = {
        modalVisible: false,
        modalRecord: {},
        modalSaving: false
    };

    handleModalShow = (record = {}) => {
        this.setState({
            modalVisible: true,
            modalRecord: record,
        })
    };

    handleModalOk = (fieldsValue) => {
        this.setState({
            modalSaving: true,
        });
        api.modifyIndustry({...fieldsValue}).then(() => {
            this.setState({
                modalSaving: false,
                modalVisible: false
            });
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({
                modalSaving: false,
            });
        })
    };

    handleDelete = (industryId) => {
        api.deleteIndustry(industryId).then(() => {
            this.dataTable.fetch();
            message.success('删除成功')
        })
    };

    render() {
        return (
            <PageHeaderLayout title={'行业管理'}>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <Button type={"primary"} onClick={() => this.handleModalShow()}>新增</Button>
                    </div>
                    <StandardTable columns={this.columns}
                                   rowKey={'id'}
                                   url={'/api/industry/'}
                                   ref={(table) => this.dataTable = table}
                    />
                </Card>
                <FormModal visible={this.state.modalVisible}
                           confirmLoading={this.state.modalSaving}
                           record={this.state.modalRecord}
                           fields={this.modifyFields}
                           onOk={this.handleModalOk}
                           onCancel={() => this.setState({modalVisible: false})}
                />
            </PageHeaderLayout>
        )
    }


}

export default Industry;
